export default "__VITE_ASSET__bZSBIbYN__"